import React, { Component } from 'react';
import Paper from '@mui/material/Paper';
import LoansGroup from './LoansGroup';
import YearlyBreakdownPopup from './YearlyPopup';
import Overview from "./Overview"
import FinancesAndEmployment from "./FinancesAndEmployment"
class AnalysisOutcome extends Component {
  state = {
    preview: null,
    expanded: false,
    consolidatedExpanded: false,
    yearlyDialog: false,
    recommendedPlan: [],
    count: 0
  };
  componentDidMount() {
    this.noOfLoanGroups()
  }
  getRecommendedPlanPayments = (plans) => {
    const recommendedPlan = plans.find((plan) => plan.recommended);
    this.setState({ recommendedPlan: recommendedPlan.repayment, yearlyDialog: true })
  };
  getYealyBreakdown = () => {
    const yealyBreakdown = this.props.analysisCollection.non_consolidated.direct.plans.filter(
      (plan) => plan.recommended
    );
    return yealyBreakdown.repayment || [];
  };
  toggleExpansion = () => {
    this.setState({ expanded: !this.state.expanded });
  };
  toggleConsolidationExpansion = () => {
    this.setState({ consolidatedExpanded: !this.state.consolidatedExpanded });
  };
  getAnalysisContext = () => {
    if (this.props.analysisCollection.analysisContext) {
      return this.props.analysisCollection.analysisContext
    }
    return {
      finances: this.props.account.finances,
      employment: this.props.account.employment
    }
  }

  noOfLoanGroups = () => {
    let count = 0;
    const { non_consolidated, consolidated } = this.props.analysisCollection;
    count = non_consolidated.non_direct.length + count;
    count = consolidated.loans.length ? ++count: count
    count =  non_consolidated.direct.loans.length  ? ++count : count
    count = non_consolidated.perkins.loans.length  ? ++count: count
    this.setState({count})
  }
  render() {
    const { analysisCollection } = this.props;
    return (
      <div className='animated fadeIn padding'>
        {this.props.preview && (
          <h2 className='text-center'>Strategy Outcome Preview</h2>
        )}
        <div className='line-break' />
        <Overview analysisCollection={analysisCollection} />
        <div className="line-break"></div>
        {<FinancesAndEmployment analysisContext={this.getAnalysisContext()} /> }
        <div className='line-break' />
        <div className='row'>
          <div className='col-12'>
            <Paper>
              {
                analysisCollection.non_consolidated.direct.loans.length
                  ? <LoansGroup
                    account={this.props.account}
                    loansGroup={analysisCollection.non_consolidated.direct}
                    consolidate={false}
                    toggleYearlyBreakdown={this.getRecommendedPlanPayments}
                    loangroups={this.state.count}
                  />
                  : ""
              }
              {
                analysisCollection.non_consolidated.perkins.loans.length
                  ? <LoansGroup
                    account={this.props.account}
                    loansGroup={analysisCollection.non_consolidated.perkins}
                    consolidate={false}
                    toggleYearlyBreakdown={this.getRecommendedPlanPayments}
                    loangroups={this.state.count}

                  />
                  : ""
              }
              {
                analysisCollection.non_consolidated.non_direct.map(eachAnalysis => <LoansGroup
                  account={this.props.account}
                  loansGroup={eachAnalysis}
                  consolidate={false}
                  loangroups={this.state.count}

                />)
              }
              {
                analysisCollection.consolidated.loans.length
                  ? <LoansGroup
                    account={this.props.account}
                    loansGroup={analysisCollection.consolidated}
                    consolidate={true}
                    toggleYearlyBreakdown={this.getRecommendedPlanPayments}
                    loangroups={this.state.count}

                  /> : ""
              }
            </Paper>
          </div>
        </div>
        {this.state.yearlyDialog && (
          <YearlyBreakdownPopup
            yearlyDialog={this.state.yearlyDialog}
            close={() => this.setState({ yearlyDialog: false })}
            recommendedPaymentPlan={this.state.recommendedPlan}
          />
        )}

        {this.props.preview && (
          <div>
            <div className='line-break' />
            <div className='row'>
              <div className='col-12 text-center'>
                <button
                  className='btn btn-secondary'
                  onClick={this.props.onClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default AnalysisOutcome;
